import Head from "next/head";
import { AuthForm } from "@/components/boardblend/auth-form";
export default function SignUpPage() {
  return (
    <>
      <Head>
        <title>Create account · Boardblend</title>
      </Head>
      <AuthForm mode="sign-up" />
    </>
  );
}
